import React, {useState,  useContext} from 'react';
import styled from 'styled-components';
import {OverlayContext} from './../../../contexts/OverlayContext';

import {OzContainer, OzCard, OzButton} from "@ozwol/webui";

const Close = styled.div`
  // color: #fff;
  cursor: pointer;
  & *{
    font-size: 20px;
  }
`;
const Content = styled.div`
    font-size: 12px;
		height: 60vh;
		overflow-x: hidden;
		overflow-y: auto;
`;

const OverlayPreviewJson = ({responseJson}) => {
	const {removeOverlay} = useContext(OverlayContext);
	const [showJson, setShowJson] = useState(1);

  return (
    <OzContainer size="medium">
			<OzCard variant={"jet"}
				headerLeft={
					<>
						<OzButton noMinWidth={true} pushed={showJson === 1} variant={"push-jet"} onClick={() => setShowJson(1)}>
							<span className="material-symbols-outlined">apps</span>
						</OzButton>
						&nbsp;
						<OzButton noMinWidth={true} pushed={showJson === 0} variant={"push-jet"} onClick={() => setShowJson(0)}>
							<span className="material-symbols-outlined">code</span>
						</OzButton> 
					</>
				}
				headerRight={<Close onClick={() => removeOverlay("preview")}><span className="material-symbols-outlined">close</span></Close>}
			>
				<Content>
					{showJson === 0 ?
						<pre style={{whiteSpace: "pre-wrap"}}>{JSON.stringify(responseJson,null,2)}</pre>
					:
						Object.keys(responseJson).map((k) => <p key={k}><b>{k}</b>:<br/> {typeof responseJson[k] === "object" ? responseJson[k].join (", ") : responseJson[k]}</p>)
					}
				</Content>
			</OzCard>
		</OzContainer>
  )
}

export default OverlayPreviewJson;
